export default {
  FINISHED: {
    value: 1,
    description: "再生終了時"
  },
  STOPPED: {
    value: 2,
    description: "一時停止時"
  },
  FINISHED_FULLSCREEN: {
    value: 3,
    description: "最大化終了時"
  },
  PASSED_TIME: {
    value: 4,
    description: "時間経過時"
  },
  ANY: {
    value: 5,
    description: "任意"
  }
}
